import { LatLng } from 'leaflet';
import { ActionType, createStandardAction } from 'typesafe-actions';

import {
  IMapSettings,
  IMapSettingsParams,
} from 'views/components/Video/MapComponent';

export interface IMapState {
  currentPosition: IMapSettings;
  savedPosition: IMapSettings;
}

const initialState: IMapState = {
  currentPosition: {
    bounds: null,
    center: new LatLng(59.953551884820094, 30.30990600585938),
    zoom: 11,
    layers: {},
    showDrawPanel: false,
  },
  savedPosition: {
    bounds: null,
    center: new LatLng(59.953551884820094, 30.30990600585938),
    zoom: 11,
    layers: {},
    showDrawPanel: false,
  },
};

export enum actionTypes {
  CHANGE_CURRENT_POSITION = 'CHANGE_CURRENT_POSITION',
  SAVE_CURRENT_POSITION = 'SAVE_CURRENT_POSITION',
  SET_SAVED_POSITION = 'SET_SAVED_POSITION',
}

export const actions = {
  changeCurrentPosition: createStandardAction(
    actionTypes.CHANGE_CURRENT_POSITION
  )<{
    settings: IMapSettingsParams;
  }>(),
  saveCurrentPosition: createStandardAction(actionTypes.SAVE_CURRENT_POSITION)<{
    settings: IMapSettingsParams;
  }>(),
  setSavedPosition: createStandardAction(actionTypes.SET_SAVED_POSITION)(),
};

type ActionTypes = ActionType<typeof actions>;

const reducer = (
  state: IMapState = initialState,
  action: ActionTypes
): IMapState => {
  switch (action.type) {
    case actionTypes.CHANGE_CURRENT_POSITION:
      return {
        ...state,
        currentPosition: {
          ...state.currentPosition,
          ...action.payload.settings,
        },
      };
    case actionTypes.SAVE_CURRENT_POSITION:
      return {
        ...state,
        savedPosition: {
          ...state.savedPosition,
          ...action.payload.settings,
        },
      };
    case actionTypes.SET_SAVED_POSITION:
      return {
        ...state,
        currentPosition: state.savedPosition,
      };
    default:
      return state;
  }
};

export default reducer;
